export { InfoBanner } from "./InfoBanner";
export type { InfoBannerColorThemes, InfoBannerProps } from "./InfoBanner";

export {
  CautionMinorOutlineIcon as InfoBannerCautionMinorIcon,
  StatusInformationOutlineIcon as InfoBannerInformationIcon,
  WarningOutlineIcon as InfoBannerWarningIcon,
  MisuseOutlineIcon as InfoBannerFailureIcon,
  HelpIcon as InfoBannerHelpIcon,
  CheckIcon as InfoBannerCheckIcon,
} from "../../icons_v2/general";
